import EmblaCarousel from 'embla-carousel';
import addArrowsClickHandlers from '../utils/arrowButtons';

const demoBenefits = document.querySelectorAll('.demo-benefits');

const addUtils = (slider, arrowBack, arrowNext) => {
  addArrowsClickHandlers(slider, arrowBack, arrowNext);
};

const initSlider = () => {
  demoBenefits.forEach((demo) => {
    const sliderViewport = demo.querySelector('.demo-benefits__viewport');

    // init carousel
    const slider = EmblaCarousel(sliderViewport, {
      active: true,
      align: 'start',
      breakpoints: {
        '(min-width: 1181px': { active: false },
      },
      containScroll: 'trimSnaps',
    });

    // add arrows click events
    const arrowBack = demo.querySelector('.slider-arrow--back');
    const arrowNext = demo.querySelector('.slider-arrow--next');
    if (arrowBack && arrowNext) {
      addUtils(slider, arrowBack, arrowNext);
    }
  });
};

(() => {
  if (demoBenefits.length) {
    initSlider();
  }
})();
